import type { Transition, Variants } from "framer-motion";

export const PUBLIC_ENTRANCE_EASE = [0.22, 1, 0.36, 1] as const;

export type PublicEntranceVariant =
  | "hero"
  | "group"
  | "subtle"
  | "reveal"
  | "slideLeft"
  | "slideRight"
  | "scale";

const HERO_OFFSET = 12;
const GROUP_OFFSET = 10;
const SUBTLE_OFFSET = 6;
const REVEAL_OFFSET = 20;
const SLIDE_OFFSET = 14;

function buildVariants(
  offsetY = 0,
  offsetX = 0,
  scaleFrom?: number,
): Variants {
  return {
    hidden: {
      opacity: 0,
      y: offsetY,
      x: offsetX,
      ...(scaleFrom != null ? { scale: scaleFrom } : {}),
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      ...(scaleFrom != null ? { scale: 1 } : {}),
    },
  };
}

export const PUBLIC_ENTRANCE_VARIANTS: Record<
  PublicEntranceVariant,
  Variants
> = {
  hero: buildVariants(HERO_OFFSET),
  group: buildVariants(GROUP_OFFSET),
  subtle: buildVariants(SUBTLE_OFFSET),
  reveal: buildVariants(REVEAL_OFFSET),
  slideLeft: buildVariants(0, -SLIDE_OFFSET),
  slideRight: buildVariants(0, SLIDE_OFFSET),
  scale: buildVariants(SUBTLE_OFFSET, 0, 0.98),
};

export const PUBLIC_ENTRANCE_REDUCED_VARIANTS: Variants = {
  hidden: { opacity: 1, y: 0, x: 0, scale: 1 },
  visible: { opacity: 1, y: 0, x: 0, scale: 1 },
};

export function getPublicEntranceTransition(
  variant: PublicEntranceVariant,
  delay = 0,
): Transition {
  const duration =
    variant === "hero" || variant === "reveal"
      ? 0.52
      : variant === "group"
        ? 0.46
        : 0.4;

  return {
    duration,
    delay,
    ease: PUBLIC_ENTRANCE_EASE,
  };
}

export const PUBLIC_ENTRANCE_BANNER_VARIANTS: Variants = {
  hidden: { opacity: 0, y: -8, height: 0 },
  visible: {
    opacity: 1,
    y: 0,
    height: "auto",
    transition: {
      duration: 0.32,
      ease: PUBLIC_ENTRANCE_EASE,
    },
  },
  exit: {
    opacity: 0,
    y: -6,
    height: 0,
    transition: { duration: 0.2, ease: "easeIn" },
  },
};

export const PUBLIC_ENTRANCE_BANNER_REDUCED_VARIANTS: Variants = {
  hidden: { opacity: 1, y: 0, height: "auto" },
  visible: { opacity: 1, y: 0, height: "auto" },
  exit: { opacity: 1, y: 0, height: "auto" },
};
